import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { Form, withFormik } from 'formik';
import compose from 'lodash/fp/compose';

import { withHigherOrderComponent } from '../../../../shared/components/with-higher-order-component/with-higher-order-component';
import { useNoSubmit } from '../../../../shared/hooks/use-no-submit/use-no-submit.hook';
import { FormikProps } from '../../../../shared/props/formik.props';
import Filter from '../../../shared/components/filter/Filter';
import BrandsDropdown from './components/brands-dropdown/brands-dropdown';
import EcusDropdown from './components/ecus-dropdown/ecus-dropdown';
import ModelsDropdown from './components/models-dropdown/models-dropdown';
import PlatformsDropdown from './components/platforms-dropdown/platforms-dropdown';
import { FirmwareFiltersFormikModel } from './models/firmware-filters-formik.model';
import { FirmwareFilterProps } from './types/firmware-filter-props.type';

const FirmwareFilter: FunctionComponent<FirmwareFilterProps> = (
  props: PropsWithChildren<FirmwareFilterProps>
): ReactElement => {
  const { children, handleSubmit } = props;

  return (
    <Form onSubmit={handleSubmit}>
      <Filter>{children}</Filter>
    </Form>
  );
};

export default withFormik<
  FormikProps<FirmwareFiltersFormikModel>,
  FirmwareFiltersFormikModel
>({
  handleSubmit: useNoSubmit(),
})(
  compose(
    withHigherOrderComponent(BrandsDropdown),
    withHigherOrderComponent(ModelsDropdown),
    withHigherOrderComponent(EcusDropdown),
    withHigherOrderComponent(PlatformsDropdown)
  )(FirmwareFilter)
);
